import { clone } from 'remeda';

import { RecommendationsSettings } from '../../../../../types/Recommendations.js';
import { RecommendationSettingsType } from '../../RecommendationSettings.types.js';

const transformUISettingsToServer = (
  settings: Partial<RecommendationSettingsType>,
): Partial<RecommendationsSettings> =>
  Object.entries(settings).reduce((acc, [key, value]) => {
    const transformed: RecommendationsSettings & { [index: string]: any } =
      clone(acc);

    switch (key) {
      case 'budgetReallocationLimits': {
        if (
          value &&
          typeof value === 'object' &&
          'min' in value &&
          'max' in value
        ) {
          transformed[key] =
            value.min === null ||
            value.max === null ||
            !settings.isBudgetLimited
              ? null
              : { min: +value.min, max: +value.max };
        }

        break;
      }
      case 'isBudgetLimited': {
        break;
      }

      default: {
        transformed[key] = value;
      }
    }

    return transformed;
  }, {} as RecommendationsSettings);

export default transformUISettingsToServer;
